import { ActionReducerMap } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

/**
 * Name store feature
 */
export const featureName = 'responder';

/**
 * Responder state interface
 */
export interface ResponderState {}

/**
 * Initial Responder state
 */
export const initialState: ResponderState = {};

/**
 * Responder reducers map
 */
export const reducers: ActionReducerMap<ResponderState> = {};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.RESPONDER,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];
